import { FlaskConical, Info } from "lucide-react";

export const ConceptBadge = ({ label = "Concept preview", className = "" }) => (
  <span className={`inline-flex items-center gap-2 rounded-full border border-cyan-400/50 bg-cyan-950/70 px-3 py-1 font-mono text-[0.65rem] uppercase tracking-[0.25em] text-cyan-200 shadow-[0_0_14px_rgba(6,182,212,0.3)] backdrop-blur ${className}`}>
    <span className="h-1.5 w-1.5 rounded-full bg-cyan-300 pulse-glow" />
    {label}
  </span>
);

export const DemoNote = ({ children, testId = "demo-note" }) => (
  <div data-testid={testId} className="flex items-start gap-3 rounded-xl border border-amber-300/30 bg-amber-300/[0.07] px-4 py-3 text-sm text-amber-100">
    <FlaskConical className="mt-0.5 h-4 w-4 shrink-0 text-amber-300" />
    <p>{children ?? "Demonstration only. This uses sample data — no AI is running and nothing you enter is saved."}</p>
  </div>
);

export const VisionNote = () => (
  <p className="flex items-center gap-2 text-xs text-slate-300">
    <Info className="h-3.5 w-3.5 text-cyan-300" />
    Conceptual representation of future possibilities — not functional software.
  </p>
);
